import Image from "next/image";
import React from "react";
import styles from "./upsc-sociology-optional.module.css";
import Carousel from 'react-bootstrap/Carousel';
import carouselBGimg3 from "../../assets/images/home/Moksha/Sociology-Web-Banner-2025.jpg";
//import carouselBGimg4 from "../../assets/images/upsc/upsc_mains.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Upsc_toppers from "./toppers";
import Link from "next/link";
import Head from "next/head";

const UPSC_Main_Test_Series_2023 = () => {
    const BGimg = [
        //{ img: carouselBGimg4, alt: "carousel", link: "/" },
        { img: carouselBGimg3, alt: "carousel", link: "/upsc-mains-test-series" }
    ]
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC Sociology Mains Test Series 2025</title>
            <meta name="title" content="UPSC Sociology Mains Test Series 2025" />
            <meta name="description" content="Prepare with UPSC Sociology Mains Test Series 2025 from Shankar IAS Academy. Practice tests, expert feedback & exam-ready strategies." />
            <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-sociology-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC Sociology Mains Test Series 2025" />
            <meta property="og:description" content="Prepare with UPSC Sociology Mains Test Series 2025 from Shankar IAS Academy. Practice tests, expert feedback & exam-ready strategies." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-sociology-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>


            <Navbar title="upsc" />

            <div className="container">
                <div className="row pt-3 pt-md-4">
                    <div className="col-md-8 col-6 ">
                        <h1 className={`${styles.pagemaintitle}`}>UPSC Sociology Mains Test Series 2025</h1>
                    </div>
                    <div className="col-md-2 col-2 offset-md-2 mt-md-3">
                        <a href="https://admissions.shankariasacademy.com/online/" target="_blank" className={`${styles.normalbutton}  d-inline-block text-center align-middle`}>Moksha Login</a>
                    </div>
                </div>
                <div className="col px-0 d-none d-md-block pb-4">
                    <Carousel>
                        {BGimg.map((e) =>
                            <Carousel.Item>
                                <div className="carousemaindiv">
                                    <Link href={e.link} rel="noreferrer"> <Image
                                        className="d-none d-md-block carouselimage"
                                        layout="fill"
                                        src={e.img}
                                        alt={e.alt}
                                        title="description"
                                    /></Link>
                                </div>
                            </Carousel.Item>
                        )}
                    </Carousel>
                </div>
                {/* small screen */}
                <div className="col px-0 d-block d-md-none">
                    <Carousel>
                        {BGimg.map((e) =>
                            <Carousel.Item>
                                <div className="smalldiv">
                                    <Link href={e.link} rel="noreferrer"> <Image
                                        className="d-block d-md-none carouselimage"
                                        layout="fill"
                                        src={e.img}
                                        alt={e.alt}
                                        title="description"
                                    /></Link>
                                </div>
                            </Carousel.Item>
                        )}
                    </Carousel>
                </div>
            </div>

            {/* <div className="container">
            <div className="row">
                <div className="col mb-2 mb-md-3">
                    <Image src={UPSC} className="img-fluid w-100" alt="upsc-mains-test-series-2023 banner" title="UPSC Main Test Series 2023"/>
                </div>
            </div>
        </div> */}

         
   {/* Mains 2024 */}
   
  {/* <div className="container d-none d-md-block">  <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC Sociology  Test Series 2024</h2>
   </div>
 
   <div className="container d-none d-md-block" style={{backgroundColor:"rgb(255, 242, 242)"}}>
        
        <div className={`${styles.classesborder} row`} style={{backgroundColor:"#FFFFFF"}}>
            <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                    <p className={`${styles.mainshead} mb-0`}>Freshers</p>
            </div>
            <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                    <p className={`${styles.mainshead} mb-0`}>Veterans</p>
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
            <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3">
            <p className={`${styles.subhead} mb-0 mb-md-2`}>Whom ?</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
            </div>   
            <div className="col-12 col-md-4 border pt-3 pb-3">
            <p className={`${styles} mb-0 mb-md-2`}>Suits aspirants appearing for
                        Mains 2024

            </p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3">
                    <p className={`${styles} mb-0`}>Suits aspirants with prior mains experience and appearing for Mains 2024</p>
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
            <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3">
            <p className={`${styles.subhead} mb-0 mb-md-2`}>Tests</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
            </div>   
            <div className="col-12 col-md-4 border pt-3 pb-3">
            <p className={`${styles} mb-0 mb-md-2`}>6 sectional tests + 4 full tests

            </p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3">
                    <p className={`${styles} mb-0`}>6 full tests</p>
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
            <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3">
            <p className={`${styles.subhead} mb-0 mb-md-2`}>Schedule</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
            </div>   
            <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
            <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/moksha-mains/sociology/2024-Socio-Freshersh.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
            <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/moksha-mains/sociology/2024-Socio-Veterans.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
            <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead}`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3">
            <p className={`${styles.subhead} mb-0 mb-md-2`}>Admission</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
            </div>   
            <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
            <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
            </div>
            <div className="col-12 d-block d-md-none ">
                    <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
            </div>
            <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
            <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
            </div>
        </div>
        

   </div>*/}
{/* Mainst 2025*/}
   {/* <div className="container d-none d-md-block">  <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC Sociology Mains Test Series 2025
   </h2>
   </div> */}
 
   <div className="container d-none d-md-block pt-4" style={{backgroundColor:""}}>
        
        <div className={`${styles.classesborder} row`} style={{backgroundColor:"rgb(255, 242, 242)"}}>
            <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                    <p className={`${styles.mainshead} mb-0`}>CHOOSE YOUR BEST FIT </p>
            </div>
            <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                    <p className={`${styles.mainshead} mb-0`}>FRESHERS</p>
            </div>
            <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                    <p className={`${styles.mainshead} mb-0`}>VETERANS</p>
            </div>
            <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                    <p className={`${styles.mainshead} mb-0`}>LONG TERM</p>
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
            <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
            <p className={`${styles.subhead} mb-0 mb-md-2`}>Whom ?</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
            </div>   
            <div className="col-12 col-md-3 border pt-3 pb-3">
            <p className={`${styles} mb-0 mb-md-2`}>Suits freshers appearing for Mains 2025

            </p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles} mb-0`}>Suits aspirants with Prior mains experience and appearing for Mains 2025

</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles} mb-0`}>Suits aspirants who want exhaustive optional answer writing practice for Mains 2026
</p>
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
            <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
            <p className={`${styles.subhead} mb-0 mb-md-2`}>Tests</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
            </div>   
            <div className="col-12 col-md-3 border pt-3 pb-3">
            <p className={`${styles} mb-0 mb-md-2`}>6 Sectional Test + 4 Full Test


            </p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles} mb-0`}>6 full Test

</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles} mb-0`}>7 Sectional Test + 3 Revison Test + 2 Full Test</p>
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
        <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles.mainshead} mb-0`}>Schedule</p>
            </div>
            
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
            </div>   
            <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
            <span className="d-inline-block pt-2"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-Sociology-optional-test-Freshers-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
            <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-sociology-optional-test-Veterans-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
            <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-sociology-optional-test-Long-Term-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
            </div>
        </div>
        <div className={`${styles.classesborder} row`}>
            <div className="col-md-12 d-block d-md-none">
                    <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles.mainshead} mb-0`}>Admission</p>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
            </div>   
            <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
            <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
            <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
            </div>
            <div className="col-12 d-block d-md-none">
                    <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
            </div>
            <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
            <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
            </div>
        </div>

   </div>

        


          {/*  <div className="container-fluid py-3 py-md-4 pt-xl-5 d-block d-md-none" id="gsttestseries">
               <div style={{background: '#fff2f2 0% 0% no-repeat padding-box', opacity: '1'}}> 
                  <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC Sociology  Test Series 2024</h2>
                    <div className="container">
                            <div className="row">  
                            
                                <div className="col-12 col-md-8 border pt-3 pb-3">
                                        <div className="row col-12 p-2">
                                            <p className={`${styles.mobhead}`}> Choose Your Best Fit </p>
                                                <div className={`${styles.bgboxbg} col-12 col-md-2 `}>
                                                        <span className="d-inline-block p-2">Freshers :</span>
                                                </div> 
                                                <div className="col-12 col-md-10 pt-2">
                                                        <span className="d-inline-block">Suits aspirants appearing for
                                                        Mains 2024<hr/>6 sectional tests + 4 full tests</span>
                                                </div> 

                                                

                                                <div className="col-12 pt-2 pb-2 text-center">
                                                    <span className="d-inline-block"><a href="https://www.shankariasacademy.com/pdf/moksha-mains/sociology/2024-Socio-Freshersh.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
                                               </div>
                                         <hr/>
                                                <div className="md-border col-12 pt-2 text-center">
                                                        <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                </div> 
                                        </div>

                                        <div className="row col-12  p-2 pt-3">
                                            <div className={`${styles.bgboxbg} col-12 col-md-2`}>
                                                    <span className="d-inline-block pt-2">Veterans :</span>
                                            </div> 
                                            <div className="col-12 col-md-10 pt-2">
                                                    <span className="d-inline-block">Suits aspirants with prior mains experience and appearing for Mains 2024 <hr/>6 full tests</span>
                                            </div>

                                                   <div className="col-12 pt-2 pb-2 text-center">
                                                    <span className="d-inline-block  "><a href="https://www.shankariasacademy.com/pdf/moksha-mains/sociology/2024-Socio-Veterans.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
                                               </div>
                                         <hr/>
                                                <div className="md-border col-12 pt-2 text-center">
                                                        <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                </div>  
                                        </div>
                                </div>
                            </div>
                        </div>
                 </div> 
             
             </div> */}

             <div className="container-fluid py-3 py-md-4 pt-xl-5 d-block d-md-none" id="gsttestseries">
               <div style={{background: '#fff2f2 0% 0% no-repeat padding-box', opacity: '1'}}> 
                  <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC Sociology Mains Test Series 2025</h2>
                    <div className="container">
                            <div className="row">  
                            
                                <div className="col-12 col-md-8 border pt-3 pb-3">
                                        <div className="row col-12 p-2">
                                            <p className={`${styles.mobhead}`}>Choose Your Best Fit</p>
                                                <div className={`${styles.bgboxbg} col-12 col-md-2 `}>
                                                        <span className="d-inline-block p-2">FRESHERS</span>
                                                </div> 
                                                <div className="col-12 col-md-10 pt-2">
                                                        <span className="d-inline-block">Suits freshers appearing for Mains 2025
                                                            <hr/>6 Sectional Test + 4 Full Test</span>
                                                </div> 

                                                <div className="col-12 pt-2 pb-2 text-center">
                                                    <span className="d-inline-block  "><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-Sociology-optional-test-Freshers-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
                                               </div>
                                         <hr/>
                                                <div className="md-border col-12 pt-2 text-center">
                                                        <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                </div> 
                                        </div>

                                        <div className="row col-12  p-2 pt-3">
                                            <div className={`${styles.bgboxbg} col-12 col-md-2`}>
                                                    <span className="d-inline-block p-2">VETERANS</span>
                                            </div> 
                                            <div className="col-12 col-md-10 pt-2 ">
                                                    <span className="d-inline-block">Suits aspirants with Prior mains experience and appearing for Mains 2025

                                                    <hr/>6 full Test</span>
                                            </div> 

                                            <div className="col-12 pt-2 pb-2 text-center">
                                                    <span className="d-inline-block  "><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-sociology-optional-test-Veterans-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
                                               </div>
                                         <hr/>
                                                <div className="md-border col-12 pt-2 text-center">
                                                        <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                </div> 
                                        </div>

                                        <div className="row col-12  p-2 pt-3">
                                            <div className={`${styles.bgboxbg} col-12 col-md-2`}>
                                                    <span className="d-inline-block p-2">LONG TERM</span>
                                            </div> 
                                            <div className="col-12 col-md-10 pt-2">
                                                    <span className="d-inline-block">Suits aspirants who want exhaustive optional answer writing practice for Mains 2026

                                                    <hr/>7 Sectional Test + 3 Revison Test + 2 Full Test</span>
                                            </div> 

                                            <div className="col-12 pt-2 pb-2 text-center">
                                                    <span className="d-inline-block  "><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-sociology-optional-test-Long-Term-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i> Click here </a></span>
                                               </div>
                                         <hr/>
                                                <div className="md-border col-12 pt-2 text-center">
                                                        <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                </div> 
                                        </div>
                                </div>
                            </div>
                        </div>
                 </div>
             
             </div>

            <Upsc_toppers />
            
          
            <Footer />
        </>
    )
}
export default UPSC_Main_Test_Series_2023;
